import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const MapPinIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 65 80" {...props}>
      <path
        fill={fill}
        d="M32.5,40.2161194 C26.3332727,40.2161194 21.3164545,35.1749254 21.3164545,28.9802985 C21.3164545,22.7844776 26.3332727,17.7444776 32.5,17.7444776 C38.6667273,17.7444776 43.6835455,22.7844776 43.6835455,28.9802985 C43.6835455,35.1749254 38.6667273,40.2161194 32.5,40.2161194 M32.5,0 C14.5800909,0 0,14.6483582 0,32.6543284 C0,40.1576119 5.16690909,50.3152239 15.3577273,62.8465672 C22.7180909,71.8949254 29.9602727,78.8155224 30.264,79.1044776 C30.8915455,79.7014925 31.6951818,80 32.5,80 C33.3048182,80 34.1084545,79.7014925 34.736,79.1044776 C35.0397273,78.8155224 42.2830909,71.8949254 49.6422727,62.8465672 C59.8330909,50.3152239 65,40.1576119 65,32.6543284 C65,14.6483582 50.4210909,0 32.5,0"
      />
    </Icon>
  );
};

MapPinIcon.propTypes = {
  fill: PropTypes.string,
};

export default MapPinIcon;
